import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './ViaForm.css';
import Form from 'react-bootstrap/Form';

function ViaForm() {
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }

        setValidated(true);
    };

    return (
        <section id='contact'>
            <div className="form-bg">
                <Container fluid>
                    <Row className='form-col-op'>
                        <Col lg={6} md={12} sm={12}>
                            <div className="form-left-div">
                                <div className="form-left-div-img"></div>
                            </div>
                        </Col>
                        <Col lg={6} md={12} sm={12}>
                            <div className='form-container'>
                                <p>Please fill out the form and we will get back to you.<br />
                                    Please detail the requested matter.</p>
                                <div>
                                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                                        <Row>
                                            <Col lg={6} md={12} sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>First Name</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="email"
                                                        placeholder="First Name"
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide your first name.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6} md={12} sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>Last Name</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="email"
                                                        placeholder="Last Name"
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide your last name.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={6} md={12} sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>Email</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="email"
                                                        placeholder="Enter Email"
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide your valid email.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                            <Col lg={6} md={12} sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>Phone</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="email"
                                                        placeholder="Enter Phone Number"
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid phone number.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={12} md={12} sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>Country</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="email"
                                                        placeholder="Enter Your Country"
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        Please provide a valid country.
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={12} md={12} sm={12}>
                                                <Form.Group className="mb-3" controlId="validationCustom03">
                                                    <Form.Label>Type you message here</Form.Label>
                                                    <Form.Control
                                                        required
                                                        placeholder="Leave a message here"
                                                        as="textarea" rows={3} />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={12} md={12} sm={12}>
                                                <div className="submit-btn">
                                                    <button type="submit">
                                                        Submit
                                                    </button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default ViaForm;